<script>
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "EventStartTime",
  elementPanelSettings: {
    displayIcon: "hugeicons:time-03",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Start Time",
  },
  extends: TextElement,
  mixins: [EventCardElementMixin, DateElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.formattedDate(this.entity.startTime);
    },
  },
};
</script>
